import moment from 'moment-timezone';

export const getBackgroundStyle = (status) => {
    if (status === 'assigned' || status === 'approved' || status === 'Accepted') {
        return { background: '#785c9933' };
    } else if (status === 'available' || status === 'Request' || status === 'New Request') {
        return { background: '#ffb82a33' };
    } else if (status === 'dnc') {
        return { background: '#3176a033' };
    } else if (status === 'cnc') {
        return { background: '#9623e033' };
    } else if (status === 'completed') {
        return { background: '#1c2b2c33' };
    } else if (status === 'cancelled') {
        return { background: '#e33a3133' };
    } 
    else if (status === 'Pending Language Approval' || status === 'pending') {
        return { background: '#1ad5982e' };
    } 
};

const getConfirmationDate = (appointment) => {
    const dateTime = appointment?.start_datetime || appointment?.datetime;
    const timezone = appointment?.appointment_details?.timezone?.name || appointment?.accounts?.timezone?.name || 'UTC';
    if (!dateTime) return null;
    return moment.tz(dateTime, timezone);
};

export const getConfirmationRowClass = (appointment) => {
    const status = (appointment?.confirmation_status || appointment?.invite_details?.status || '').toString().toLowerCase();
    if (status === 'confirmed' || status === 'accepted') {
        return 'confirmation-row-confirmed';
    }
    if (status === 'cancelled' || status === 'declined' || status === 'rejected') {
        return 'confirmation-row-cancelled';
    }
    if (status === 'link_opened') {
        return 'confirmation-row-link-opened';
    }

    const confirmationDate = getConfirmationDate(appointment);
    if (!confirmationDate) {
        return '';
    }

    const hoursLeft = confirmationDate.diff(moment(), 'hours', true);
    if (hoursLeft <= 1 && hoursLeft >= 0) {
        return 'confirmation-row-confirm-asap';
    }
    if (hoursLeft <= 24 && hoursLeft > 1) {
        return 'confirmation-row-confirmation-pending';
    }

    return '';
};

export const getConfirmationBadge = (appointment) => {
    const status = (appointment?.confirmation_status || appointment?.invite_details?.status || '').toString().toLowerCase();
    if (status === 'confirmed' || status === 'accepted') {
        return { text: 'Confirmed', type: 'success' };
    }
    if (status === 'cancelled' || status === 'declined' || status === 'rejected') {
        return { text: 'Cancelled', type: 'danger' };
    }
    if (status === 'link_opened') {
        return { text: 'Link opened', type: 'warning' };
    }

    const confirmationDate = getConfirmationDate(appointment);
    if (!confirmationDate) {
        return null;
    }

    const hoursLeft = confirmationDate.diff(moment(), 'hours', true);
    if (hoursLeft <= 1 && hoursLeft >= 0) {
        return { text: 'Confirm ASAP', type: 'danger' };
    }
    if (hoursLeft <= 24 && hoursLeft > 1) {
        return { text: 'Confirmation pending', type: 'warning' };
    }

    return null;
};

export const getEyeStyle = (status, highlightOverride = null) => {

    if (highlightOverride === 'red') {
        return { background: '#ffcccc' };
    }
    if (highlightOverride === 'yellow') {
        return { background: '#ffb82a' };
    }
    if (highlightOverride === 'green') {
        return { background: 'rgb(18 241 168 / 74%)' };
    }

    if (status === 'assigned' || status === 'Accepted') {
        return { background: '#785c99' };
    } else if (status === 'available' || status === 'Request' || status === 'New Request') {
        return { background: '#ffb82a' };
    } else if (status === 'dnc') {
        return { background: '#3176a0' };
    } else if (status === 'cnc') {
        return { background: '#9623e0' };
    } else if (status === 'completed') {
        return { background: '#1c2b2c' };
    } else if (status === 'cancelled') {
        return { background: '#e33a31' };
    } 
    else if (status === 'Pending Language Approval') {
        return { background: '#1AD598' };
    } 
};

export const legends = [
  {
    id: 1, name: "Available",
    value: "available",
    color: "#FFB82A"
  },
  {
    id: 2, name: "Assigned",
    value: "assigned",
    color: "#785C99"
  },
  {
    id: 3, name: "Cancelled",
    value: "cancelled",
    color: "#E33A31"
  },
  {
    id: 4, name: "CNC",
    value: "cnc",
    color: "#9623E0"
  },
  {
    id: 5, name: "DNC",
    value: "dnc",
    color: "#3176a0"
  },
  {
    id: 6, name: "Completed",
    value: "completed",
    color: "#1C2B2C"
  },
  
  
];

export const interpreterLegends = [
  {
    id: 1, name: "Available",
    value: "available",
    color: "#FFB82A"
  },
  {
    id: 4, name: "Completed",
    value: "completed",
    color: "#1C2B2C"
  },
  {
    id: 5, name: "Cancelled",
    value: "cancelled",
    color: "#E33A31"
  },
  {
    id: 8, name: "Declined",
    value: "declined",
    color: "#b51a12"
  },
];

export const vendorLegends = [
  {
    id: 1, name: "Pending",
    value: "pending",
    color: "#3176A0"
  },
  {
    id: 2, name: "Assigned",
    value: "assigned",
    color: "#785C99"
  },
  {
    id: 3, name: "Completed",
    value: "completed",
    color: "#1C2B2C"
  },
  {
    id: 4, name: "Cancelled",
    value: "vendor_cancelled",
    color: "#E33A31"
  },
  {
    id: 5, name: "Declined",
    value: "vendor_declined",
    color: "#b51a12"
  },
  {
    id: 6, name: "Extra Mileage",
    value: "extra_mileage",
    color: "#1ad598"
  },
];


export const filteredClientStatus = [
  {
    id: 1,
    name: "New Request",
    value: "new request",
    color: "#FFB82A", // blue dark
    textColor: "#6C889C",
  },
  {
    id: 2,
    name: "Quote Received",
    value: "quote sent",
    color: "#607D8B", // indigo dark
    textColor: "#6C889C",
  },
  {
    id: 3,
    name: "Quote Rejected",
    value: "quote rejected",
    color: "#DC2626", // red dark
    textColor: "#6C889C",
  },
  {
    id: 4,
    name: "Quote Revised",
    value: "quote revised",
    color: "#7C3AED", // purple dark
    textColor: "#6C889C",
  },
  {
    id: 5,
    name: "Quote Approved",
    value: "quote approved",
    color: "#10B981", // green dark
    textColor: "#6C889C",
  },
  {
    id: 6,
    name: "Translators Invited",
    value: "translators invited",
    color: "#6B7280", // green dark
    textColor: "#6C889C",
  },
  {
    id: 7,
    name: "Assigned",
    value: "assigned",
    color: "#2563EB", // blue dark
    textColor: "#6C889C",
  },
  {
    id: 8,
    name: "Under Review",
    value: "under review",
    color: "#7A5AF5", // purple dark
    textColor: "#6C889C",
  },
  {
    id: 9,
    name: "Client Cancelled",
    value: "client cancelled",
    color: "#EF4444", // red dark
    textColor: "#6C889C",
  },
  {
    id: 10,
    name: "Submission Rejected",
    value: "submission rejected",
    color: "#DC2626", // deep red
    textColor: "#6C889C",
  },
  {
    id: 11,
    name: "Invoice Sent",
    value: "invoice sent",
    color: "#1E3A8A", // indigo deep
    textColor: "#6C889C",
  },
  {
    id: 12,
    name: "Translator Declined",
    value: "translator declined",
    color: "#B51A12", // deep red
    textColor: "#6C889C",
  },
  {
    id: 13,
    name: "Cancelled",
    value: "cancelled",
    color: "#DC2626", // red dark
    textColor: "#6C889C",
  },
  {
    id: 14,
    name: "Completed",
    value: "completed",
    color: "#000000", // green dark
    textColor: "#6C889C",
  },
];


export const filteredStatuses = [
  {
    id: 1,
    name: "New Request",
    value: "new request",
    color: "#FFB82A", // blue dark
    textColor: "#6C889C",
  },
  {
    id: 2,
    name: "Quote Sent",
    value: "quote sent",
    color: "#607D8B", // indigo dark
    textColor: "#6C889C",
  },
  {
    id: 3,
    name: "Quote Rejected",
    value: "quote rejected",
    color: "#DC2626", // red dark
    textColor: "#6C889C",
  },
  {
    id: 4,
    name: "Quote Revised",
    value: "quote revised",
    color: "#7C3AED", // purple dark
    textColor: "#6C889C",
  },
  {
    id: 5,
    name: "Quote Approved",
    value: "quote approved",
    color: "#10B981", // green dark
    textColor: "#6C889C",
  },
  {
    id: 6,
    name: "Translators Invited",
    value: "translators invited",
    color: "#6B7280", // green dark
    textColor: "#6C889C",
  },
  {
    id: 7,
    name: "Assigned",
    value: "assigned",
    color: "#2563EB", // blue dark
    textColor: "#6C889C",
  },
  {
    id: 8,
    name: "Under Review",
    value: "under review",
    color: "#7A5AF5", // purple dark
    textColor: "#6C889C",
  },
  {
    id: 9,
    name: "Client Cancelled",
    value: "client cancelled",
    color: "#EF4444", // red dark
    textColor: "#6C889C",
  },
  {
    id: 10,
    name: "Submission Rejected",
    value: "submission rejected",
    color: "#DC2626", // deep red
    textColor: "#6C889C",
  },
  {
    id: 11,
    name: "Invoice Sent",
    value: "invoice sent",
    color: "#1E3A8A", // indigo deep
    textColor: "#6C889C",
  },
  {
    id: 12,
    name: "Translator Declined",
    value: "translator declined",
    color: "#B51A12", // deep red
    textColor: "#6C889C",
  },
  {
    id: 13,
    name: "Cancelled",
    value: "cancelled",
    color: "#DC2626", // red dark
    textColor: "#6C889C",
  },
  {
    id: 14,
    name: "Completed",
    value: "completed",
    color: "#000000", // green dark
    textColor: "#6C889C",
  },
];

export const filteredStatusINterpreter = [
  {
    id: 7,
    name: "Assigned",
    value: "assigned",
    color: "#2563EB", // blue dark
    textColor: "#6C889C",
  },
  {
    id: 8,
    name: "Under Review",
    value: "under review",
    color: "#7A5AF5", // purple dark
    textColor: "#6C889C",
  },
  {
    id: 10,
    name: "Submission Rejected",
    value: "submission rejected",
    color: "#DC2626", // deep red
    textColor: "#6C889C",
  },
  {
    id: 11,
    name: "Submission Approve",
    value: "invoice sent",
    color: "#1E3A8A", // indigo deep
    textColor: "#6C889C",
  },
  {
    id: 14,
    name: "Completed",
    value: "completed",
    color: "#000000", // green dark
    textColor: "#6C889C",
  },
];

export const LegendButton = ({ options, activeId, handleClick }) => {
  return (
    options.map((legend) => (
      <div
        key={legend.name}
        className={`border_btn ${activeId === legend.id ? "active_border" : ""}`}
      >
        <button
          className={`button-bu ${legend?.value == "High" && "tigerLine"}`}
          style={{ backgroundColor: legend.color }}
          onClick={() => handleClick(legend.id, legend.value)}
        >
          <p>{legend.name}</p>
        </button>
      </div>
    )))
}